import { Component, OnInit, Input, OnChanges } from '@angular/core';
import {
  DVFormArray,
  DVFormControl,
  DVFormGroup
} from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { Validators } from '@angular/forms';
import * as _ from 'lodash';
@Component({
  selector: 'app-add-package-price',
  templateUrl: './add-package-price.component.html',
  styleUrls: ['./add-package-price.component.css']
})
export class AddPackagePriceComponent {
  @Input() packageForm: DVFormGroup;
  constructor() {}
}
